import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    maxWidth: '730px',
    width: '95%',
    padding: '33px 59px 36px 59px', // ? figma values
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    border: `1px solid ${theme.custom.whiteColor}`,
    backdropFilter: 'blur(52px)',
    borderRadius: '24px',
    margin: theme.spacing(2, 6),
    '& .MuiInputBase-root': {
      height: '66px',
      borderRadius: '112px',
      [theme.breakpoints.down('md')]: {
        borderRadius: '70px',
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 2.5),
      height: 'auto',
    },
  },
  BgImgContainer: {
    width: '100%',
    height: 'auto',
    minHeight: '100vh',
    background:
      'linear-gradient(360deg, rgba(255,255,255,1) 0%, rgba(0,0, 0 ,0) 60%, rgba(0,0, 0 ,0) 100%)',
    zIndex: -999,
  },
  bgImage: {
    position: 'absolute',
    top: 89,
    left: 0,
    right: 0,
    zIndex: -1,
  },
  headingContainer: {
    width: '100%',
    textAlign: 'center',
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '36px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    padding: theme.spacing(3, 0, 2),

    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
    },
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ':focus': {
      borderBottom: 'none !important',
    },
    ':hover': {
      borderBottom: 'none !important',
      border: 'none !important',
      outline: 'none',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      outline: 'none',
      width: '100%',
      height: '66px',
      color: 'black',
      borderRadius: '112px',
      textAlign: 'start',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      paddingBottom: theme.spacing(2),
    },

    '& .MuiFormControl-root': {
      ' > *': {
        borderBottom: 'none !important',
        ':focus': {
          borderBottom: 'none !important',
        },
        ':hover': {
          borderBottom: 'none !important',
        },
        ':after': {
          border: 'none !important',
        },
        ':before': {
          border: 'none !important',
        },
      },
    },

    '& .mui-style-piqwo0-MuiInputBase-root-MuiFilledInput-root': {
      background: 'none !important',
      ':focus': {
        border: 'none !important',
      },
    },
  },
  textfieldContainer: {
    width: '100%',
    minWidth: '676px',
    height: '66px',
    background: theme.custom.whiteColor,
    border: '1px solid #C5CED6',
    padding: theme.spacing(1, 4),
    margin: theme.spacing(2, 0),
    borderRadius: '112px',
    color: 'black',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  inputLabel: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '17px',
    color: theme.custom.blackColor,
    opacity: 0.6,
    paddingTop: theme.spacing(1),
    textTransform: 'capitalize',
  },
  formTextField: {
    width: '100%',
    minWidth: '676px',
    height: '66px',
    background: theme.custom.whiteColor,
    border: '1px solid #C5CED6',
    borderRadius: '112px',
    outline: 'none',
    padding: theme.spacing(0, 5.5),
    margin: theme.spacing(4, 0),
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      height: '60px',
    },
  },
  checkboxContainer: {
    width: '100%',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    flexDirection: 'row',
  },
  checkboxLabel: {
    paddingTop: theme.spacing(3),
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: 'normal',
    color: theme.custom.blackColor,
  },
  tandcLinks: {
    color: theme.custom.blackColor,
  },
  tandcCheckbox: {
    marginBottom: theme.spacing(7),
  },
  submitBtn: {
    width: '100%',
    maxWidth: '676px',
    height: '66px',
    background: theme.custom.drawerBgColor,
    borderRadius: '112px',
    marginTop: theme.spacing(6),
    fontFamily: 'Nunito Sans',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '18px',
    lineHeight: '25px',
    color: theme.custom.lightFont,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontWeight: 700,
      fontSize: '16px',
    },
  },
  loginBtn: {
    width: '100%',
    padding: theme.spacing(4, 0),
    background: '#1C1C1C',
    color: 'white',
    textAlign: 'center',
    '&:hover': {
      background: '#1C1C1C',
      color: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  btnWrapper: {
    width: '100%',
    margin: theme.spacing(4, 0, 0),
  },
}))

export default useStyles
